module.exports = __webpack_public_path__ + "img/B14-20190411_05.b6f4a5aa.jpg";